<div class="container pt-4 pb-5">
  <div class="container-shadow px-4">
    <h2 class="pt-5 pb-3 sticky-top bg-white border-bottom">
      <div class="float-right">
        <div class="btn-group">
          <button type="button" class="btn btn-primary" (click)="saveDocTemplate()" [disabled]="docTemplate.deleting || docTemplate.saving">
            <i class="fas fa-save"></i>&nbsp;
            {{ docTemplate.saving ? 'Saving' : 'Save' }}
            <span *ngIf="docTemplate.saving">
              &nbsp;
              <i class="fas fa-spinner fa-pulse fa-fw"></i>
            </span>
          </button>
          <button type="button" class="btn btn-danger" *ngIf="docTemplate.id" (click)="deleteDocTemplate()" [disabled]="docTemplate.deleting || docTemplate.saving">
            <i class="fas fa-trash"></i>&nbsp;
            {{ docTemplate.deleting ? 'Deleting' : 'Delete' }}
            <span *ngIf="docTemplate.deleting">
              &nbsp;
              <i class="fas fa-spinner fa-pulse fa-fw"></i>
            </span>
          </button>
          <button type="button" class="btn btn-outline-secondary" (click)="previewDocTemplate()">Preview</button>
          <button type="button" class="btn btn-outline-secondary" (click)="previewDocTemplate(true)">Preview Inline</button>
          <button type="button" class="btn btn-outline-warning" *ngIf="docTemplate.id" (click)="checkAllTags()" [disabled]="checkingAllTags" title="Scan every part on this template for tag errors">
            <i class="fas fa-tags"></i>&nbsp;{{ checkingAllTags ? 'Checking…' : 'Check All Tags' }}
          </button>
          <button type="button" class="btn btn-info" *ngIf="docTemplate.id" (click)="showCloneInput = !showCloneInput" [disabled]="cloning">
            <i class="fas fa-copy"></i>&nbsp;Clone
          </button>
        </div>
        <span *ngIf="showCloneInput" class="ml-2">
          <input type="text" class="form-control d-inline-block" style="width: 260px; vertical-align: middle;" placeholder="Name for the cloned template" [(ngModel)]="cloneName" name="cloneName" (keyup.enter)="cloneDocTemplate()" [disabled]="cloning" />
          <button type="button" class="btn btn-success ml-1" (click)="cloneDocTemplate()" [disabled]="cloning">
            <i class="fas fa-check"></i>&nbsp;{{ cloning ? 'Cloning' : 'Create Clone' }}
            <span *ngIf="cloning">&nbsp;<i class="fas fa-spinner fa-pulse fa-fw"></i></span>
          </button>
          <button type="button" class="btn btn-link" (click)="showCloneInput = false; cloneName = ''" [disabled]="cloning">Cancel</button>
        </span>
        &nbsp;
        <a class="btn btn-link" href="#" (click)="$event.preventDefault(); newDocTemplate()"><i class="fas fa-plus-circle"></i>&nbsp;New Template</a>
        &nbsp;
        <a class="btn btn-link" [routerLink]="'/hunspell_spell_check'"><i class="fas fa-book"></i>&nbsp;Custom dictionary</a>
      </div>
      {{ docTemplate && docTemplate.id ? 'Editing' : 'New' }} Template
    </h2>

    <div *ngIf="allTagResults" class="alert alert-secondary mt-3">
      <button type="button" class="close" (click)="clearAllTagResults()" aria-label="Close"><span>&times;</span></button>
      <h5><i class="fas fa-tags"></i>&nbsp;Tag check — all parts</h5>
      <div *ngFor="let r of allTagResults" class="mt-2">
        <strong [ngClass]="{'text-success': r.valid, 'text-danger': !r.valid}">
          <i class="fas" [ngClass]="{'fa-check-circle': r.valid, 'fa-exclamation-circle': !r.valid}"></i>&nbsp;Part {{ r.index + 1 }} — {{ r.name }}
        </strong>
        <ul class="list-unstyled mb-0 ml-4" *ngIf="r.errors.length">
          <li *ngFor="let err of r.errors" class="mb-2" [ngClass]="{
            'text-danger':  err.severity === 'error',
            'text-warning': err.severity === 'warning',
            'text-info':    err.severity === 'info'
          }">
            <div><span *ngIf="err.line">Line {{ err.line }}: </span>{{ err.message }}</div>
            <div *ngIf="err.snippet" class="text-muted" style="font-family: monospace; font-size: 0.85em; padding-left: 20px; word-break: break-all;">{{ err.snippet }}</div>
            <div *ngIf="err.snippet" style="padding-left: 20px; margin-top: 2px;">
              <a href="#" (click)="$event.preventDefault(); jumpToSnippet(r.index, err.snippet)" title="Jump to this tag in the editor">
                <i class="fas fa-crosshairs"></i>&nbsp;show me
              </a>
              <a href="#" (click)="$event.preventDefault(); copySnippet(err.snippet)" class="ml-2 text-muted" title="Copy snippet">
                <i class="fas fa-copy"></i>&nbsp;copy
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="pt-4"></div>
    <form #currentForm="ngForm">
      <fieldset>
        <div class="form-row" *ngIf="docTemplate.id">
          <div class="col">
            <label>
              <strong>Selected Template:&nbsp;</strong>
              <span class="text-muted font-italic">{{ docTemplate.name }}</span>
            </label>
          </div>
        </div>
        <div class="form-row" [ngClass]="{ 'mt-3': docTemplate.id }">
          <div class="col-md-2">
            <label>Template Name</label>
          </div>
          <div class="col-md-10">
            <input type="text" name="name" [appAutocomplete]="'/doc_templates/autocomplete_name'" (autocompleteSelect)="editDocTemplate($event)" [(ngModel)]="docTemplateSearchTerm" class="form-control" placeholder="Search for existing template by same name or create a new one" />
          </div>
        </div>
        <div class="form-row mt-3">
          <div class="col-md-2">
            <label>Template Description</label>
          </div>
          <div class="col-md-10">
            <app-tinymce *ngIf="!loading" #tinymce [initialContent]="docTemplate.description" (onEditorKeyup)="docTemplate.description = $event"></app-tinymce>
          </div>
        </div>        
        <div class="form-row mt-3">
          <div class="col-md-2"></div>
          <div class="col-md-6 border-right">
            <div class="form-row">
              <div class="col-md-6">     
                <label style="opacity: 0;">Matter Type</label>
                <div class="custom-control custom-checkbox" (click)="docTemplate.is_global = !docTemplate.is_global">
                  <input type="checkbox" name="is_global" class="custom-control-input" [checked]="docTemplate.is_global" />
                  <label class="custom-control-label">Is Global</label>
                </div>
                <div class="custom-control custom-checkbox" (click)="docTemplate.is_letter = !docTemplate.is_letter">
                  <input type="checkbox" name="is_letter" class="custom-control-input" [checked]="docTemplate.is_letter" />
                  <label class="custom-control-label">Is Letter</label>
                </div>
              </div>
              <div class="col-md-6">
                <label style="opacity: 0;">Matter Type</label>
                <div class="custom-control custom-checkbox" (click)="docTemplate.require_proof = !docTemplate.require_proof">
                  <input type="checkbox" name="requires_proof" class="custom-control-input" [checked]="docTemplate.require_proof" />
                  <label class="custom-control-label">Require Proof</label>
                </div>
                <div class="custom-control custom-checkbox" (click)="docTemplate.require_envelope = !docTemplate.require_envelope">
                  <input type="checkbox" name="requires_envelope" class="custom-control-input" [checked]="docTemplate.require_envelope" />
                  <label class="custom-control-label">Require Envelope</label>
                </div>
                <div class="pt-2"></div>
              </div> 
            </div>           
            <div class="card mt-2">
              <div class="card-body p-2">
                <div class="custom-control custom-checkbox" (click)="docTemplate.send_check = !docTemplate.send_check">
                  <input type="checkbox" name="send_check" class="custom-control-input" [checked]="docTemplate.send_check" />
                  <label class="custom-control-label">Requires Check</label>
                </div>
                <div class="pt-2"></div>
                <input type="number" placeholder="Amount" name="check_amount" class="form-control" [(ngModel)]="docTemplate.amount" [disabled]="!docTemplate.send_check" />
                <div class="pt-2"></div>
                <app-contact-search [contactId]="docTemplate.payee" [editable]="docTemplate.send_check" [placeholder]="'Payee'" (contact_id)="docTemplate.payee = $event" #checkPayeeSearch></app-contact-search>
              </div>
            </div>
          </div>
          <div class='col-md-4'>            
            <label>Matter Type</label>
            <select class="form-control" name="matter_type_id" [(ngModel)]="docTemplate.matter_type_id">
              <option *ngFor="let matterType of formOptions.matter_types" [value]="matterType.value">{{ matterType.label }}</option>
            </select>
            <div class="pt-2"></div>
            <label>Activity</label>
            <select class="form-control" name="activity_id" [(ngModel)]="docTemplate.activity_id">
              <option *ngFor="let activity of formOptions.activities" [value]="activity.value">{{ activity.label }}</option>
            </select>
            <div class="pt-2"></div>
            <label>Matter for template preview</label>
            <app-matter-search [matterId]="docTemplate.matter_id" [placeholder]="'Matter number'" (matter_id)="docTemplate.matter_id = $event"></app-matter-search>
          </div>
        </div>        
        <div class="form-row mt-3">
          <div class="col-sm-10 ml-auto">
            <div class="custom-control custom-checkbox" (click)="docTemplate.merge_parts = !docTemplate.merge_parts">
              <input type="checkbox" name="merge_parts" class="custom-control-input" [checked]="docTemplate.merge_parts" />
              <label class="custom-control-label">Merge parts when loaded in documents</label>
            </div>
            <small class="form-text text-muted">To be used for specific requirements such as mail merge</small>
          </div>
        </div>
        <div class="form-row mt-3">
          <div class="col-md-2">
            <label>Tags</label>
          </div>
          <div class="col-sm-10">
            <input type="text" placeholder="Tags" name="tag_list" class="form-control" [(ngModel)]="docTemplate.tag_list" />
          </div>
        </div>
        <div class="form-row mt-3">
          <div class="col-sm-2">
            <label>Document Type</label>
          </div>
          <div class="col-sm-10">
            <app-document-type-search [documentTypeId]="docTemplate.document_type_id" (document_type_id)="docTemplate.document_type_id = $event"></app-document-type-search>
          </div>
        </div>
        <div class="form-row mt-3">
          <div class="col-md-2">
            <label>Watermark</label>
          </div>
          <div class="col-md-5">
            <select class="form-control" name="logo" placeholder="Watermark" [(ngModel)]="docTemplate.logo_id">
              <option *ngFor="let logo of formOptions.logos" [value]="logo.value">{{ logo.label }}</option>
            </select>
          </div>
          <div class="col-md-2">
            <label>Watermark start page</label>
          </div>
          <div class="col-md-3">
            <input class="form-control" type="number" min="1" name="watermark_start_page" placeholder="Watermark start page" [(ngModel)]="docTemplate.watermark_start_page" />
          </div>
        </div>
        <div class="form-row mt-3">
          <div class="col-md-2">
            <label>Stylesheets</label>
          </div>
          <div class="col-md-10">
            <div class="card">
              <div class="card-body">
                <app-stylesheet-search [include_item]="true" [select_only]="true" (stylesheet)="addStylesheet($event)"></app-stylesheet-search>
                <small class="form-text text-muted">(Select to add)</small>
                <div class="form-row pt-2">
                  <div class="col">
                    <div class="card mb-1" *ngIf="docTemplate && docTemplate.stylesheets">
                      <div class="card-header">
                        <div class="btn-group btn-group-sm pull-right float-right">
                          <button class="btn btn-outline-secondary btn-sm" type="button" [disabled]="docTemplate.saving" (click)="applyStylesheets()"><i class="fas fa-redo"></i>Apply</button>
                          <button class="btn btn-outline-secondary btn-sm" type="button" [disabled]="docTemplate.saving" (click)="saveStylesheets()"><i class="fas fa-save"></i>&nbsp;Save</button>
                        </div>
                        Selected Stylesheets
                      </div>
                      <div class="card-body limited-height-medium">
                        <div *ngFor="let stylesheet of docTemplate.stylesheets; let i = index" class="p-1">
                          <a class="float-right text-danger" href="#" (click)="$event.preventDefault(); removeStylesheet(i)">
                            <i class="fas fa-times"></i>
                          </a>
                          {{ stylesheet.label }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend>Parts</legend>
        <div class="pb-5">
          <div  [appNativeSortableJs]="docTemplate.doc_parts" [sortableOptions]="sortableOptions">
            <div *ngFor="let docPart of docTemplate.doc_parts; let i = index" class="py-2">
              <div class="card">
                <div class="card-header">
                  <div class="form-row">
                    <div class="col-sm-2">
                      <label>
                        <div class="d-inline-block">
                          <div class="alias-sort-handle d-inline-block py-1 px-2" style="cursor: grab" title="Sort">
                            <i class="fas fa-random"></i>
                          </div>
                          &nbsp;
                          <a href="#" (click)="$event.preventDefault(); docPart.expanded = !docPart.expanded">
                            <i class="fas" [ngClass]="{ 'fa-minus-circle': docPart.expanded, 'fa-plus-circle': !docPart.expanded }"></i>
                          </a>
                        </div>
                        Part Name
                      </label>
                    </div>
                    <div class="col-sm-8">
                      <input type="text" class="form-control" [name]="'doc_part_name_' + (docPart.id || 'new_' + i)" [appAutocomplete]="'/doc_parts/autocomplete_doc_part_name'" (autocompleteSelect)="editDocPart($event, i, null)" [(ngModel)]="docPart.searchTerm" />
                    </div>
                    <div class="col-sm-2">
                      <button class="btn btn-sm btn-block btn-outline-secondary" [disabled]="docTemplate.saving" (click)="addNewDocPart(i)"><i class="fas fa-plus-circle"></i>&nbsp;Add new part</button>
                    </div>
                  </div>
                  <div class="form-row mt-2">
                    <div class="col-sm-2">
                      <label>
                        <div class="d-inline-block" style="width: 46px !important"></div>
                        Part Type
                      </label>
                    </div>
                    <div class="col-sm-8">
                      <select class="form-control" [name]="'doc_part_type_' + docPart.id" [(ngModel)]="docPart.type">
                        <option *ngFor="let docPartType of formOptions.doc_part_types" [value]="docPartType.value">{{ docPartType.label }}</option>
                      </select>
                    </div>
                    <div class="col-sm-2" *ngIf="!docPart.id">
                      <label class="text-primary">(New Part)</label>
                    </div>
                  </div>
                  <div class="form-row mt-2" *ngIf="docPartErrors && docPartErrors[i]">
                    <div class="col">
                      <div class="alert alert-danger">
                        {{ docPartErrors[i] }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-body" *ngIf="docPart.expanded">
                  <div class="form-row">
                    <div class="col-sm-2">
                      <div class="form-group">
                        <label>Matter Type</label>
                        <select class="form-control" [name]="'matter_type_id_' + docPart.id" [(ngModel)]="docPart.matter_type_id">
                          <option *ngFor="let matterType of formOptions.matter_types" [value]="matterType.value">{{ matterType.label }}</option>
                        </select>
                      </div>
                      <div class="form-group">
                        <div class="custom-control custom-checkbox" (click)="docPart.is_global = !docPart.is_global">
                          <input type="checkbox" [name]="'is_global_' + docPart.id" class="custom-control-input" [checked]="docPart.is_global" />
                          <label class="custom-control-label">Is Global</label>
                        </div>
                        <div class="custom-control custom-checkbox" (click)="docPart.expand_part = !docPart.expand_part">
                          <input type="checkbox" [name]="'expand_pa_' + docPart.idrt" class="custom-control-input" [checked]="docPart.expand_part" />
                          <label class="custom-control-label">Expand Part</label>
                        </div>
                        <div class="custom-control custom-checkbox" (click)="docPart.mandatory = !docPart.mandatory">
                          <input type="checkbox" [name]="'mandatory_' + docPart.id" class="custom-control-input" [checked]="docPart.mandatory" />
                          <label class="custom-control-label">Mandatory</label>
                        </div>
                      </div>
                      <div class="form-group">
                        <button type="button" class="btn btn-sm btn-block btn-primary mt-2" (click)="saveDocPart(docPart, i)" [disabled]="docPart.saving || docTemplate.saving">
                          <i class="fas fa-save"></i>&nbsp;
                          {{ docPart.saving ? 'Saving' : 'Save' }}
                          <span *ngIf="docPart.saving">
                            &nbsp;
                            <i class="fas fa-spinner fa-fw fa-pulse"></i>
                          </span>
                        </button>
                        <button type="button"
                                class="btn btn-sm btn-block btn-info mt-2"
                                *ngIf="docPart.id"
                                title="Create a new DocPart from this part's current contents so edits won't affect other templates that share it"
                                (click)="saveDocPartAsNew(docPart, i)"
                                [disabled]="docPart.saving || docTemplate.saving">
                          <i class="fas fa-copy"></i>&nbsp;Save as New Part
                        </button>
                        <button type="button"
                                class="btn btn-sm btn-block btn-outline-warning mt-2"
                                title="Scan this part's contents for unknown / unbalanced Radius tags"
                                (click)="checkTags(docPart, i)"
                                [disabled]="docPart.saving">
                          <i class="fas fa-tag"></i>&nbsp;Check Tags
                        </button>
                        <button type="button"
                                class="btn btn-sm btn-block btn-outline-secondary mt-2"
                                title="With the cursor inside (or on) a Radius tag in the editor, extend the selection through the matching closing tag"
                                (click)="selectToEndTag(i)"
                                [disabled]="docPart.saving">
                          <i class="fas fa-angle-double-right"></i>&nbsp;Select to End Tag
                        </button>
                        <div *ngIf="tagErrors[i]" class="mt-2 p-2 border rounded" style="font-size: 0.85em; max-height: 280px; overflow-y: auto;">
                          <button type="button" class="btn btn-sm btn-link float-right p-0" (click)="clearTagErrors(i)" title="Dismiss"><i class="fas fa-times"></i></button>
                          <strong>Tag check results:</strong>
                          <ul class="list-unstyled mb-0 mt-1">
                            <li *ngFor="let err of tagErrors[i]"
                                class="mb-2"
                                [ngClass]="{
                                  'text-success': err.severity === 'ok',
                                  'text-danger':  err.severity === 'error',
                                  'text-warning': err.severity === 'warning',
                                  'text-info':    err.severity === 'info',
                                  'text-muted':   err.severity === 'pending'
                                }">
                              <div>
                                <i class="fas" [ngClass]="{
                                  'fa-check-circle':  err.severity === 'ok',
                                  'fa-exclamation-circle': err.severity === 'error',
                                  'fa-exclamation-triangle': err.severity === 'warning',
                                  'fa-info-circle':   err.severity === 'info',
                                  'fa-spinner fa-pulse': err.severity === 'pending'
                                }"></i>
                                <span *ngIf="err.line">&nbsp;Line {{ err.line }}:</span>
                                &nbsp;{{ err.message }}
                              </div>
                              <div *ngIf="err.snippet" class="text-muted" style="font-family: monospace; font-size: 0.85em; padding-left: 20px; word-break: break-all;">{{ err.snippet }}</div>
                              <div *ngIf="err.snippet" style="padding-left: 20px; margin-top: 2px;">
                                <a href="#" (click)="$event.preventDefault(); jumpToSnippet(i, err.snippet)" title="Jump to this tag in the editor">
                                  <i class="fas fa-crosshairs"></i>&nbsp;show me
                                </a>
                                <a href="#" (click)="$event.preventDefault(); copySnippet(err.snippet)" class="ml-2 text-muted" title="Copy snippet">
                                  <i class="fas fa-copy"></i>&nbsp;copy
                                </a>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <button type="button" class="btn btn-sm btn-block btn-outline-secondary mt-2" (click)="removeDocPart(i)" [disabled]="docTemplate.saving"><i class="fas fa-times"></i>&nbsp; Remove</button>
                        <button type="button" class="btn btn-sm btn-block btn-danger mt-2" *ngIf="docPart.id" (click)="deleteDocPart(docPart, i)" [disabled]="docPart.saving || docPart.deleting">
                          <i class="fas fa-trash"></i>&nbsp;
                          {{ docPart.deleting ? 'Deleting' : 'Delete' }}
                          <span *ngIf="docPart.deleting">
                            &nbsp;
                            <i class="fas fa-spinner fa-fw fa-pulse"></i>
                          </span>
                        </button>
                      </div>
                    </div>
                    <div class="col-sm-8 text-center">
                      <app-tinymce-css
                        [elementId]="'tinymce-' + i + '-doc-part-' + i"
                        [css_files]="css_files"
                        [stylesheet_formats]="stylesheet_formats"
                        #tinymceCss
                        [initialContent]="docPart.contents"
                        (onEditorKeyup)="docPart.contents = $event"
                        *ngIf="docPart.type != 'to' && docPart.type != 'cc' && docPart.type != 'signature'"
                      ></app-tinymce-css>
                      <textarea class="form-control" rows="6" *ngIf="docPart.type == 'to' || docPart.type == 'cc' || docPart.type == 'signature'" [name]="'doc_part_' + i + '_contents'" [(ngModel)]="docPart.contents" [disabled]="true"></textarea>
                    </div>
                    <div class="col-sm-2">
                      <div class="form-group">
                        <label>Add word to dictionary</label>
                        <input type="text" class="form-control" placeholder="add word" />
                        <div class="pt-2"></div>
                        <button type="button" class="btn btn-sm btn-outline-secondary btn-block">Add</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
    </form>
    <div class="pt-4"></div>
    <div id="preview_inline_holder" style="width: 100%">
      <iframe id="preview_content" frameBorder="0" name="preview_content" width="100%" height="100%"></iframe>
    </div>
    <div class="pt-4"></div>
  </div>
</div>
